/**
 * 格式化金额为人民币格式
 * @param {number|string} amount - 金额
 * @param {number} decimals - 小数位数，默认为2
 * @returns {string} 格式化后的金额字符串，例如：¥1,234.56
 */
function formatCurrency(amount, decimals = 2) {
	if (amount === null || amount === undefined || amount === '') {
		return '¥0.00';
	}

	const num = typeof amount === 'string' ? parseFloat(amount) : amount;

	if (isNaN(num)) {
		return '¥0.00';
	}

	// 格式化为指定位数的小数
	const fixed = num.toFixed(decimals);

	// 添加千位分隔符
	const parts = fixed.split('.');
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

	return `¥${parts.join('.')}`;
}

/**
 * 待办统计等窄位展示用金额缩写：k / 万 / M
 * @param {number|string} amount
 * @returns {string} 例如：¥12.8k、¥3.5万、¥1.2M
 */
export function formatCurrencyCompact(amount) {
	if (amount === null || amount === undefined || amount === '') {
		return '¥0';
	}
	const num = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
	if (!Number.isFinite(num)) {
		return '¥0';
	}
	const abs = Math.abs(num);
	const sign = num < 0 ? '-' : '';
	if (abs >= 1e6) {
		return `${sign}¥${(abs / 1e6).toFixed(abs >= 1e7 ? 0 : 1)}M`;
	}
	if (abs >= 10000) {
		return `${sign}¥${(abs / 10000).toFixed(abs >= 100000 ? 1 : 2)}万`;
	}
	if (abs >= 1000) {
		return `${sign}¥${(abs / 1000).toFixed(1)}k`;
	}
	return `${sign}¥${Math.round(abs).toLocaleString('zh-CN')}`;
}

export default formatCurrency;
